import { RootState } from "@/app/stores"
import { getStoresBonusTransactionsStatistics, getStoresGeo, IPartnerStoreGeo, IStoresBonusTransactionStatistics } from "@/shared/api/partners"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchStoreGeo = createAsyncThunk<
    IPartnerStoreGeo[],
    void,
    { state: RootState }
>('partnerMap/fetchStoreGeo', async (_, thunkAPI) => {
    try {
        const { selectedPartner } = thunkAPI.getState().partnerMap
        const data = await getStoresGeo(selectedPartner ? [selectedPartner] : null)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchStoreStatistics = createAsyncThunk<
    IStoresBonusTransactionStatistics,
    void,
    { state: RootState }
>('partnerMap/fetchStoreStatistics', async (_, thunkAPI) => {
    try {
        const { selectedPartner, startDate, endDate } = thunkAPI.getState().partnerMap
        const data = await getStoresBonusTransactionsStatistics(startDate, endDate, selectedPartner ? [selectedPartner] : null)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})